import React, { useState, useEffect, useRef } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useDispatch, connect } from "react-redux";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  Button,
  makeStyles,
  IconButton,
  Tooltip,
  Modal,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Popover,
  List,
  ListItem,
  ListItemText,
} from "@material-ui/core";

import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import logo from "../assets/images/logo-main-white.png";
import spinner from "../assets/images/loadingGif.gif";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import accessToken from "../helpers/jwt-token-access/accessToken";
import jwtDecode from "jwt-decode";
import { addUser, addUserError, getUser, updateCognitoUser, deleteCognitoUser } from "../store/actions";
// import Alert from "@mui/material/Alert";
// import AlertTitle from "@mui/material/AlertTitle";
import { Alert } from "reactstrap";

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "#193a6f",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const Users = (props) => {
  const classes = useStyles();

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [groupName, setGroupName] = useState("");
  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");

  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [editedRowData, setEditedRowData] = useState(null); // State for tracking currently edited row data
  const [editFirstNameError, setEditFirstNameError] = useState("");
  const [editLastNameError, setEditLastNameError] = useState("");
  const [editEmailError, setEditEmailError] = useState("");
  const [editDialogOpen, setEditDialogOpen] = useState(false); //State for tracking dialog open/close

  const token = accessToken();
  const decoded = jwtDecode(token);
  const userName = decoded["email"];
  const userRole = decoded["cognito:groups"];

  const dispatch = useDispatch();

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const isFirstRender = useRef(true);

  useEffect(() => {
    //  const user = dispatch(getUser())
    if(userRole.includes('Admin')){
      props.getUser();
    }
    // console.log("gET uSER :: ", props.getUser())
  }, []);

  // console.log("gET uSER :: ", props.users);
  console.log("Component rerendered with props = ", props)
  const [anchorEl, setAnchorEl] = useState(null);

  const columns = [
    // { field: "id", headerName: "First Name" },
    { field: "firstName", headerName: "First Name", width: 120 },
    { field: "lastName", headerName: "Last Name", width: 120 },
    { field: "groupname", headerName: "Group Name", width: 120 },
    { field: "status", headerName: "Status", width: 80 },
    { field: "userCreatedDate", headerName: "Created Date", width: 200 },
    { field: "userModifiedDate", headerName: "Modified Date", width: 200 },
    // { field: "lastModifiedDate", headerName: "Last Modified Date", width: 200 },
    // {
    //   field: "username",
    //   headerName: "Username",
    //   renderCell: () => null,
    //   width: 1,
    // },
    // { field: "email", headerName: "email" },
    { field: "email", headerName: "Username", width: 200 },
    {
      field: "edit",
      headerName: "Edit",
      width: 100,
      renderCell: (params) => {
        // Check if the user is an admin
        if (userRole.includes("Admin")) {
          return (
            <IconButton color="primary" onClick={() => handleEdit(params.row)}>
              <EditIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton color="primary" disabled className="Mui-disabled">
              <EditIcon />
            </IconButton>
          );
        }
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 100,
      renderCell: (params) => {
        // Check if the user is an admin
        if (userRole.includes("Admin")) {
        return (
          <IconButton
            color="secondary"
            onClick={() => {
              console.log("params.row = ", params.row);
              props.deleteUser(params.row.username);
              //Added the following
              // props.getUser();
            }}
          >
            <DeleteIcon />
          </IconButton>
        );
        } else {
          return (
            <IconButton color="secondary" disabled className="Mui-disabled">
              <DeleteIcon />
            </IconButton>
          );
        }
      },
    },
  ];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseAnchor = () => {
    setAnchorEl(null);
  };

  const openAnchor = Boolean(anchorEl);
  const id = openAnchor ? "simple-popover" : undefined;

  // For Add user Modal
  const handleOpen = () => {
    setAddDialogOpen(true);
  };

  // For Add user Modal
  const handleClose = () => {
    setAddDialogOpen(false);
  };

  // For Add user Modal, change in email field
  const handleEmailChange = (event) => {
    let valid = true;
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!email || !emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      valid = false;
    } else {
      setEmailError("");
    }
    setEmail(event.target.value);
  };

  //For Submitting data of Add User to API
  const handleSubmit = (e) => {
    e.preventDefault();
    let valid = true;

    if (!firstName || !lastName) {
      setNameError("Please enter your first and last name");
      valid = false;
    } else {
      setNameError("");
    }

    // Check for valid email address
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!email || !emailRegex.test(email)) {
      setEmailError("Please enter a valid email address");
      valid = false;
    } else {
      setEmailError("");
    }

    if (valid) {
      const getRandomElement = (arr) => {
        const rand = Math.floor(Math.random() * arr.length);
        return arr[rand];
      };

      const generateRandomPasswordSelection = (length) => {
        const uppercase = [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];
        const lowercase = [
          "a",
          "b",
          "c",
          "d",
          "e",
          "f",
          "g",
          "h",
          "i",
          "j",
          "k",
          "l",
          "m",
          "n",
          "o",
          "p",
          "q",
          "r",
          "s",
          "t",
          "u",
          "v",
          "w",
          "x",
          "y",
          "z",
        ];
        const special = [
          "~",
          "!",
          "@",
          "#",
          "$",
          "%",
          "^",
          "&",
          "*",
          "(",
          ")",
          "_",
          "+",
          "-",
          "=",
          "{",
          "}",
          "[",
          "]",
          ":",
          ";",
          "?",
          ", ",
          ".",
          "|",
          "\\",
        ];
        const numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

        const nonSpecial = [...uppercase, ...lowercase, ...numbers];

        let password = "";

        for (let i = 0; i < length; i++) {
          // Previous character is a special character
          if (i !== 0 && special.includes(password[i - 1])) {
            password += getRandomElement(nonSpecial);
          } else password += getRandomElement([...nonSpecial, ...special]);
        }

        return password;
      };

      const password = generateRandomPasswordSelection(16);
      console.log("Password :: ", password);
      const newUser = {
        firstname: firstName,
        lastname: lastName,
        email,
        password,
        groupName,
      };
      console.log("Handle Submit Called :: ", newUser);
      //   dispatch(addUser(newUser));
      props.addUser(newUser);
      // console.log("Add uSer Error from Steate ::", props.addUserError);
    }
  };

  // For Edit user Modal, close the modal
  const handleEditClose = () => {
    setEditedRowData(null); // Reset edited row data
    setEditDialogOpen(false);
  };

  // For Edit user Modal, select the user
  const handleEdit = (rowData) => {
    console.log("rowData=", rowData);
    let row = { ...rowData, newgroupname: rowData.groupname };
    setEditedRowData(row); // Set the edited row data
    setEditDialogOpen(true); // Open the edit dialog
  };

  // For Edit user Modal, change in email field
  const handleEditEmailChange = (event) => {
    let valid = true;
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!editedRowData.email || !emailRegex.test(editedRowData.email)) {
      setEditEmailError("Please enter a valid email address");
      valid = false;
    } else {
      setEditEmailError("");
    }
    setEditedRowData({
      ...editedRowData,
      email: event.target.value,
    });
  };

  //For Submitting data of Edit User to API
  const handleUpdateUser = (e) => {
    e.preventDefault();
    let valid = true;

    if (!editedRowData.firstName) {
      setEditFirstNameError("Please enter your first name");
      valid = false;
    } else {
      setEditFirstNameError("");
    }
    if (!editedRowData.lastName) {
      setEditLastNameError("Please enter your last name");
      valid = false;
    } else {
      setEditLastNameError("");
    }

    // Check for valid email address
    const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
    if (!editedRowData.email || !emailRegex.test(editedRowData.email)) {
      setEditEmailError("Please enter a valid email address");
      valid = false;
    } else {
      setEditEmailError("");
    }
    console.log("editedRowData=", editedRowData);
    if (valid) {
      let updatedUser = {
        firstName: editedRowData.firstName,
        lastName: editedRowData.lastName,
        groupname: editedRowData.groupname,
        username: editedRowData.username,
      };
      if (editedRowData.groupname !== editedRowData.newgroupname) {
        updatedUser = {
          ...updatedUser,
          newgroupname: editedRowData.newgroupname,
        };
      }
      console.log("updatedUser=", updatedUser);
      props.updateUser(updatedUser);
      // handleEditClose();
    }
  };

  // Close Add dialog automatically
  useEffect(() => {
    console.log("useEffect for closing add dialog");
    if (!props.isAddingUser && !props.addUserError) {
      // Add successful, close the dialog box
      setAddDialogOpen(false);
    }
  }, [props.isAddingUser, props.addUserError]);

  // Close Edit dialog automatically
  useEffect(() => {
    console.log("useEffect for closing edit dialog")
    if (!props.isUpdatingUser && !props.updateUserError) {
      // Edit successful, close the dialog box
      // handleEditClose();
        setEditDialogOpen(false);
        setEditedRowData(null); // Reset edited row data
    }
  }, [props.isUpdatingUser, props.updateUserError]);

  useEffect(() => {
    if (isFirstRender.current) {
      console.log("First Rendered");
      isFirstRender.current = false;
    } else {
      if (props.users) {
        if (props.users.length > 0) {
          // setShowSuccessMessage(true);
          setTimeout(() => {
            setShowSuccessMessage(false);
          }, 5000); // Hide the success message after 5 seconds
        }
      }
    }
    setAddDialogOpen(false);
    setEditDialogOpen(false);
    // return () => {
    //   isFirstRender.current = true;
    // };
  }, [props.users]);

  // useEffect(() => {
  //       if (props.users) {
  //         if (props.users.length > 0) {
  //           setShowSuccessMessage(true);
  //           setTimeout(() => {
  //             setShowSuccessMessage(false);
  //           }, 15000); // Hide the success message after 15 seconds
  //         }
  //       }
  //     setAddDialogOpen(false);
  //     setEditDialogOpen(false);
  // }, [props.users]);

  // const handleDeleteUser = (params) => {
  //   props.deleteTrialUser(params.row);
  // };

  return (
    <div>
      {userRole.includes("Admin") ? (
        <div
          style={{
            justifyContent: "center",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleOpen}
            style={{ margin: "10px 10px", alignSelf: "flex-start" }}
          >
            Add User
          </Button>

          {/* Data grid to display users */}
          <div>
            {props.users && (
              <>
                {showSuccessMessage && (
                  <Alert className="mt-3 mb-0" color="success">
                    User list updated successfully!
                  </Alert>
                )}
                {props.getUsersError && (
                  <Alert className="mt-3 mb-0" color="danger">
                    {JSON.stringify(props.error)}
                    {JSON.stringify(props.message)}
                  </Alert>
                )}
                {props.isGettingUsers ? (
                  <div
                    style={{
                      display: "flex",
                      direction: "row",
                      alignContent: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      justifyItems: "center",
                      height: "100vh",
                    }}
                  >
                    <img src={spinner} width="32px" alt="Spinner" />
                  </div>
                ) : (
                  <DataGrid
                    columns={columns}
                    rows={props.users}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                      toolbar: {
                        csvOptions: { disableToolbarButton: true },
                        printOptions: { disableToolbarButton: true },
                        showQuickFilter: true,
                        quickFilterProps: { debounceMs: 500 },
                      },
                    }}
                    getRowId={(row) => row.username}
                    autoHeight
                  />
                )}
              </>
            )}
            {!props.users && (
              <div
                style={{
                  display: "flex",
                  direction: "row",
                  alignContent: "center",
                  alignItems: "center",
                  justifyContent: "center",
                  justifyItems: "center",
                  height: "100vh",
                }}
              >
                <img src={spinner} width="80px" alt="Spinner" />
              </div>
            )}
          </div>

          {/* Modal to Edit a user */}
          <Modal
            className={classes.modal}
            open={editDialogOpen}
            onClose={handleEditClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className={classes.paper}>
              <h2 id="simple-modal-title">Edit User</h2>
              {props.isUpdatingUser && (
                <img src={spinner} width="32px" alt="Spinner" />
              )}
              {props.updateUserError && (
                <Alert className="mt-3 mb-0" color="danger">
                  Error while updating a user.
                  {JSON.stringify(props.updateUserError)}
                </Alert>
              )}
              <form
                className={classes.form}
                // onSubmit={handleUpdateUser}
              >
                <TextField
                  id="firstname"
                  label="First Name"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  autoFocus
                  error={editFirstNameError !== ""}
                  helperText={editFirstNameError}
                  value={editedRowData ? editedRowData.firstName : ""}
                  // onChange={(e) => setFirstName(e.target.value)}
                  onChange={(e) =>
                    setEditedRowData({
                      ...editedRowData,
                      firstName: e.target.value,
                    })
                  }
                />
                <TextField
                  id="lastname"
                  label="Last Name"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  autoFocus
                  error={editLastNameError !== ""}
                  helperText={editLastNameError}
                  value={editedRowData ? editedRowData.lastName : ""}
                  // onChange={(e) => setLastName(e.target.value)}
                  onChange={(e) =>
                    setEditedRowData({
                      ...editedRowData,
                      lastName: e.target.value,
                    })
                  }
                />
                <TextField
                  id="email"
                  label="Email"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  autoFocus
                  error={editEmailError !== ""}
                  helperText={editEmailError}
                  value={editedRowData ? editedRowData.email : ""}
                  onChange={handleEditEmailChange}
                />
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel id="group-name">Group Name</InputLabel>
                  <Select
                    labelId="group-name"
                    id="group-name-select"
                    required
                    value={editedRowData ? editedRowData.newgroupname : ""}
                    // onChange={(e) => setGroupName(e.target.value)}
                    onChange={(e) =>
                      setEditedRowData({
                        ...editedRowData,
                        newgroupname: e.target.value,
                      })
                    }
                    label="Group Name"
                  >
                    <MenuItem value={"Admin"}>Admin</MenuItem>
                    <MenuItem value={"PowerUser"}>Power User</MenuItem>
                    <MenuItem value={"Users"}>Users</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  type="submit"
                  // fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  onClick={handleUpdateUser}
                  disabled={props.isUpdatingUser}
                >
                  Save Changes
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setEditDialogOpen(false)}
                  style={{ margin: "10px 10px", alignSelf: "flex-start" }}
                >
                  Cancel
                </Button>
              </form>
            </div>
          </Modal>
          {/* Add data grid to display users */}

          {/* Modal to add a user */}
          <Modal
            className={classes.modal}
            open={addDialogOpen}
            onClose={handleClose}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className={classes.paper}>
              <h2 id="simple-modal-title">Add User</h2>
              {props.isAddingUser && (
                <img src={spinner} width="32px" alt="Spinner" />
              )}
              {props.addUserError && (
                <Alert className="mt-3 mb-0" color="danger">
                  Error while adding a user.
                  {JSON.stringify(props.addUserError)}
                </Alert>
              )}
              <form className={classes.form} onSubmit={handleSubmit}>
                <TextField
                  id="firstname"
                  label="First Name"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  autoFocus
                  error={nameError !== ""}
                  helperText={nameError}
                  value={firstName}
                  onChange={(e) => setFirstName(e.target.value)}
                />
                <TextField
                  id="lastname"
                  label="Last Name"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  autoFocus
                  error={nameError !== ""}
                  helperText={nameError}
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
                <TextField
                  id="email"
                  label="Email"
                  variant="outlined"
                  required
                  fullWidth
                  margin="normal"
                  autoFocus
                  error={emailError !== ""}
                  helperText={emailError}
                  value={email}
                  onChange={handleEmailChange}
                />
                <FormControl variant="outlined" fullWidth margin="normal">
                  <InputLabel id="group-name">Group Name</InputLabel>
                  <Select
                    labelId="group-name"
                    id="group-name-select"
                    required
                    value={groupName}
                    onChange={(e) => setGroupName(e.target.value)}
                    label="Group Name"
                  >
                    <MenuItem value={"Admin"}>Admin</MenuItem>
                    <MenuItem value={"PowerUser"}>Power User</MenuItem>
                    <MenuItem value={"Users"}>Users</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  type="submit"
                  // fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  // onClick={handleAddUser}
                  disabled={props.isAddingUser}
                >
                  Add User
                </Button>
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => setAddDialogOpen(false)}
                  style={{ margin: "10px 10px", alignSelf: "flex-start" }}
                >
                  Cancel
                </Button>
              </form>
            </div>
          </Modal>
        </div>
      ) : (
        <div>
          <h1>Not Authorized</h1>
        </div>
      )}
    </div>
  );
};

const mapStatetoProps = (state) => {
  const {
    isAddingUser,
    addUserError,
    isUpdatingUser,
    updateUserError,
    isUserDeleting,
    deleteUserError,
    isGettingUsers,
    getUsersError,

    // loading,
    // userError,
    users,
  } = state.cognitoUser;
  return {
    isAddingUser,
    addUserError,
    isUpdatingUser,
    updateUserError,
    isUserDeleting,
    deleteUserError,
    isGettingUsers,
    getUsersError,
    users,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addUser: (user) => {
      dispatch(addUser(user));
    },
    getUser: () => {
      dispatch(getUser());
    },
    updateUser: (user) => {
      dispatch(updateCognitoUser(user));
    },
    deleteUser: (username) => {
      dispatch(deleteCognitoUser(username));
    },
  };
};

export default connect(mapStatetoProps, mapDispatchToProps)(Users);